import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeService } from '../../../services/employee.service';
import { Employee } from '../../../models/employee.model';
import { CreateEmployeeDto } from '../../../models/dtos/createEmployee.dto';
import { UpdateEmployeeDto } from '../../../models/dtos/updateEmployee.dto';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { TabViewModule } from 'primeng/tabview';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    DropdownModule,
    InputNumberModule,
    TabViewModule,
  ],
  selector: 'app-form-employee',
  templateUrl: './form-employee.component.html',
  styleUrls: ['./form-employee.component.css'],
})
export class FormEmployeeComponent implements OnInit {
  form!: FormGroup;
  isEditMode = false;
  id?: number;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private employeeService: EmployeeService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      fullName: ['', Validators.required],
      active: [true],
      nickName: [null as string | null],
      cpf: [null as string | null],
      rg: [null as string | null],
      cep: [null as string | null],
      address: [null as string | null],
      addressNumber: [null as string | null],
      addressComplement: [null as string | null],
      district: [null as string | null],
      state: [null as string | null],
      city: [null as string | null],
      paymentDay: [null as number | null],
      phone: [null as string | null],
      cellPhone: [null as string | null],
      whatsApp: [null as string | null],
      email: [null as string | null],
    });

    this.id = Number(this.route.snapshot.paramMap.get('id'));
    if (this.id) {
      this.isEditMode = true;
      this.employeeService.find(this.id).subscribe({
        next: (response) => {
          if (response.data) {
            const d = response.data;
            this.form.patchValue({
              fullName: d.fullName ?? '',
              active: d.active ?? true,
              nickName: d.nickName ?? null,
              cpf: d.cpf ?? null,
              rg: d.rg ?? null,
              cep: d.cep ?? null,
              address: d.address ?? null,
              addressNumber: d.addressNumber ?? null,
              addressComplement: d.addressComplement ?? null,
              district: d.district ?? null,
              state: d.state ?? null,
              city: d.city ?? null,
              paymentDay: d.paymentDay ?? null,
              phone: d.phone ?? null,
              cellPhone: d.cellPhone ?? null,
              whatsApp: d.whatsApp ?? null,
              email: d.email ?? null,
            });
          }
        },
      });
    }
  }

  private toCreateDto(value: any): CreateEmployeeDto {
    return {
      fullName: value.fullName,
      active: value.active ?? true,
      nickName: value.nickName || null,
      cpf: value.cpf || null,
      rg: value.rg || null,
      cep: value.cep || null,
      address: value.address || null,
      addressNumber: value.addressNumber || null,
      addressComplement: value.addressComplement || null,
      district: value.district || null,
      state: value.state || null,
      city: value.city || null,
      paymentDay: value.paymentDay != null ? value.paymentDay : null,
      phone: value.phone || null,
      cellPhone: value.cellPhone || null,
      whatsApp: value.whatsApp || null,
      email: value.email || null,
    };
  }

  private toUpdateDto(value: any): UpdateEmployeeDto {
    return {
      fullName: value.fullName ?? null,
      active: value.active ?? null,
      nickName: value.nickName || null,
      cpf: value.cpf || null,
      rg: value.rg || null,
      cep: value.cep || null,
      address: value.address || null,
      addressNumber: value.addressNumber || null,
      addressComplement: value.addressComplement || null,
      district: value.district || null,
      state: value.state || null,
      city: value.city || null,
      paymentDay: value.paymentDay != null ? value.paymentDay : null,
      phone: value.phone || null,
      cellPhone: value.cellPhone || null,
      whatsApp: value.whatsApp || null,
      email: value.email || null,
    };
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    const value = this.form.value;

    if (this.isEditMode && this.id) {
      this.employeeService.update(this.id, this.toUpdateDto(value)).subscribe({
        next: () => this.router.navigate(['/app/employees']),
        error: () => alert('Erro ao atualizar funcionário.'),
      });
    } else {
      this.employeeService.create(this.toCreateDto(value)).subscribe({
        next: () => this.router.navigate(['/app/employees']),
        error: () => alert('Erro ao cadastrar funcionário.'),
      });
    }
  }

  goBack(): void {
    this.router.navigate(['/app/employees']);
  }
}
